import { Component, OnInit } from '@angular/core';
import { DialogComponent, DialogService } from "ng2-bootstrap-modal";
import { LimitFlowProposalService } from '../../../service/limit-flow-proposal/limit-flow-proposal.service';
import { FlashMessagesService } from 'angular2-flash-messages';
import { ActivatedRoute, Router } from '@angular/router';

export interface RequestPendingModel {
	accountClientID: string,
	proposalID: string,
	proposalCTC: string,
	proposalRepresentative: string,
	userProfile: string
}

@Component({
	selector: 'app-request-pending',
	templateUrl: './request-pending.component.html',
	styleUrls: ['./request-pending.component.scss'],
	providers: [
		LimitFlowProposalService
	]
})
export class RequestPendingComponent extends DialogComponent<RequestPendingModel, boolean> implements RequestPendingModel {

	accountClientID: string;
	proposalID: string;
	proposalCTC: string;
	proposalRepresentative: string;
	userProfile: string;

	public ctcs: any[] = [];
	public representatives: any[] = [];

	public ctc: string = "";
	public representative: string = "";
	public mensagem;

	constructor(dialogService: DialogService, private router: Router, private flashMessagesService: FlashMessagesService, private limitFlowProposalService: LimitFlowProposalService) {
		super(dialogService);
	}

	ngOnInit() {
		this.getCtcByAccountClient(this.accountClientID);
		this.getRepresentativeByAccountClient(this.accountClientID);
	}

	setPending(target) {
		if (target === 'representante') {
			this.ctc = "";
		} else if (target === 'ctc') {
			this.representative = "";
		} else {
			this.ctc = "";
			this.representative = "";
		}
	}

	getCtcByAccountClient(id) {
		this.limitFlowProposalService.getCtcByAccountClient(id).subscribe(result => {
			if (result.Success) {
				this.ctcs = result.Result;

				this.ctc = (!this.proposalCTC && this.ctcs.length === 1 ? this.ctcs[0].CodigoSap : this.proposalCTC);

				this.setPending('ctc');
			} else {
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
			}
		}, error => {
			console.log(error);
		})
	}

	getRepresentativeByAccountClient(id) {
		this.limitFlowProposalService.getRepresentativeByAccountClient(id).subscribe(result => {
			if (result.Success) {
				this.representatives = result.Result;

				this.representative = (!this.proposalRepresentative && this.representatives.length === 1 ? this.representatives[0].ID : this.proposalRepresentative);

				this.setPending('representante');
			} else {
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
			}
		}, error => {
			console.log(error);
		})
	}

	requestPending() {
		var data = {};

		if (this.mensagem.length <= 5000) {
			if (this.ctc != "") {
				data = {
					ID: this.proposalID,
					CodigoSap: this.ctc,
					Mensagem: this.mensagem
				}

				this.limitFlowProposalService.requestCtcPending(data).subscribe(result => {
					if (result.Success) {
						this.flashMessagesService.show("Solicitação encaminhada ao CTC", { cssClass: 'alert-success', timeout: 6000 });
						this.confirm();
					} else {
						this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
					}
				}, error => {
					console.log(error);
				})
			} else if (this.representative != "") {
				data = {
					ID: this.proposalID,
					RepresentanteID: this.representative,
					Mensagem: this.mensagem
				}

				this.limitFlowProposalService.requestRepresentativePending(data).subscribe(result => {
					if (result.Success) {
						this.flashMessagesService.show("Solicitação encaminhada ao Representante", { cssClass: 'alert-success', timeout: 6000 });
						this.confirm();
					} else {
						this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
					}
				}, error => {
					console.log(error);
				})
			}
		} else {
			this.flashMessagesService.show("Esta mensagem excedeu o máximo de caracteres permitido. (max. 5000 caracteres)", { cssClass: 'alert-danger', timeout: 6000 });
		}
	}

	confirm() {
		this.result = true;
		this.close();
	}
}



// WEBPACK FOOTER //
// ./src/app/limit-flow-proposal/component/actions/request-pending/request-pending.component.ts